"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var graphFactories_1 = require("./graphFactories");
exports.linear = function (x) {
    return x;
};
exports.circular = function (x) {
    return -(Math.sqrt(1 - Math.pow(x, 2)) - 1);
};
exports.exponential = function (x) {
    return Math.pow(2, ((x - 1) * 10));
};
exports.squared = graphFactories_1.powerFactory(2);
exports.cubed = graphFactories_1.powerFactory(3);
exports.quad = graphFactories_1.powerFactory(4);
// Derived from Penner's elastic easing (http://robertpenner.com/easing/)
exports.elastic = function (x) {
    var s = 1.70158;
    var p = 0.3;
    var a = 1;
    var moduleX = x;
    if (moduleX === 0) {
        return 0;
    }
    if (moduleX === 1) {
        return 1;
    }
    if (a < 1) {
        a = 1;
        s = p / 4;
    }
    else {
        s = (p / (Math.PI * 2)) * Math.asin(1 / a);
    }
    moduleX -= 1;
    return -(a * Math.pow(2, (moduleX * 10)) * Math.sin(((moduleX - s) * (Math.PI * 2)) / p));
};
